import { useEffect } from 'react'
import { useEffectEvent } from 'use-effect-event'

import { isResolvedOrdinaryEvent } from '@/legacy-src/components/calendars/client/multibooking/utils'
import toaster from '@/legacy-src/utilities/toaster'

import { useCart } from '@/src/domains/cart/hooks/useCart'
import { useCartResolve } from '@/src/domains/cart/hooks/useCartResolve'

export const useCartFreeIntroSessionGuard = () => {
  const { data: cart } = useCartResolve({ suspense: false })
  const { removeSlot } = useCart()

  const handleBlockedSlots = useEffectEvent(() => {
    if (cart === undefined) {
      return
    }

    const blockedSlots = cart.events
      .filter(isResolvedOrdinaryEvent)
      .filter((e) => e.notAvailableErrors.some((err) => err.type === 'FREE_INTRO_SESSION_NOT_ELIGIBLE'))

    if (blockedSlots.length === 0) {
      return
    }

    blockedSlots.forEach((e) => removeSlot(e.startDate))
    toaster.error('component.cart.slotErrors.freeIntroSessionAlreadyUsed')
  })

  useEffect(() => {
    handleBlockedSlots()
  }, [cart])
}
